import { AppStore } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

const AppsIosFilterIcon = () => (
    <AppStore
        size="xs"
        color={colorsPalettes.carbon["200"]}
    />
);

export default AppsIosFilterIcon;
